<template>
    <Form :model="actionData">
        <FormItem prop="goods" class="goods_info_formItem">
            <panel class="create_comment_panel">
                <div class="orderitems-message">
                    <van-image :src="goodsinfo.img_url" />
                    <div class="content">
                        <div class="content-title-price-num">
                            <div class="title">{{goodsinfo.goods_name}}</div>
                            <div class="price-and-num">
                                <div class="price">&yen;&nbsp;{{goodsinfo.price}}</div>

                            </div>
                        </div>
                        <div class="info">
                            <div class="left">
                                <div style="font-size:12px" v-for="(item,i) in goodsinfo.attribute_info" :key="i">
                                    {{item.attribute_name}}:{{item.attribute_option_name}}&nbsp;</div>
                            </div>

                            <div class="num right">&times;{{goodsinfo.num}}</div>
                        </div>
                    </div>
                </div>
            </panel>
        </FormItem>
        <FormItem prop="rate">
            <div class="rate_item">
                <span>描述相符</span>
                <van-rate color="#ee0a24" v-model="actionData.description_score" />
            </div>
            <div class="rate_item">
                <span>物流服务</span>
                <van-rate color="#ee0a24" v-model="actionData.logistics_score" />
            </div>
            <div class="rate_item">
                <span>服务态度</span>
                <van-rate color="#ee0a24" v-model="actionData.serve_score" />
            </div>
        </FormItem>
        <FormItem prop="comment">
            <i-input type="textarea" placeholder="从多个角度评价商品(200字以内)" v-model="actionData.comment" :rows="5"
                :maxlength="200" />
        </FormItem>
        <FormItem prop="icon">
            <van-uploader v-model="imgList" :max-count="3" multiple :after-read="afterRead" :accept="'image/*'"
                :before-delete="deleteUploadImg" class="goodscomment_uploadimg">
                <div class="create_goods_comment_uploadimg">
                    <van-icon name="photograph" color="#dcdee0" size="24" class="plus_icon" />
                    <span>上传图片</span>
                    <span>最多3张</span>
                </div>
            </van-uploader>
        </FormItem>
    </Form>
</template>

<script>
    import {
        httpRequest
    } from "@/ajax";
    export default {
        data() {
            return {
                url: 'market-order/create-evaluate',
                imgList: [],
                uploadImg: [],
                actionData: {
                    description_score: 0,
                    logistics_score: 0,
                    serve_score: 0,
                    comment: '',
                    img: '',
                    order_num: this.selection.order_num
                },
                goodsinfo: this.selection.goodsinfo
            }
        },
        methods: {
            deleteUploadImg(file, detail) {
                this.imgList.splice(detail.index, 1)
                this.uploadImg.splice(detail.index, 1)
            },
            afterRead(file) {
                var that = this
                const fd = new FormData();
                if (file instanceof Array) {
                    for (var i = 0; i < file.length; i++) {
                        fd.append("file", file[i].file);
                        httpRequest({
                            method: "post",
                            url: "upload-img"
                        }, fd).then(rs => {
                            if (rs.status == 1) {
                                that.uploadImg.push(rs.data.url)
                            }
                        })
                    }
                } else {
                    fd.append("file", file.file);
                    httpRequest({
                        method: "post",
                        url: "upload-img"
                    }, fd).then(rs => {
                        if (rs.status == 1) {
                            that.uploadImg.push(rs.data.url)
                        }
                    })
                }

            },
            _validate() {
                return new Promise((resolve, reject) => {
                    var {
                        description_score,
                        logistics_score,
                        serve_score,
                        comment
                    } = this.actionData

                    if (description_score == 0) {
                        reject(new Error("请给描述相符评分"));
                    } else if (logistics_score == 0) {
                        reject(new Error("请给物流服务评分"));
                    } else if (serve_score == 0) {
                        reject(new Error("请给服务态度评分"));
                    } else if (comment == '') {
                        reject(new Error("请填写商品评价"));
                    } else {
                        resolve()
                    }
                })
            },
        },
        watch: {
            uploadImg: {
                immediate: true,
                handler(u) {
                    this.actionData.img = u.join(',')
                }
            }
        }
    }
</script>

<style lang="less" >
    .goods_info_formItem {
        .ivu-form-item-content {
            line-height: unset;
        }
    }

    .create_comment_panel {
        padding: 0;
        line-height: unset;

        //内容
        .orderitems-message {
            display: flex;
            padding: 0;

            .van-image {
                float: left;
                margin-right: 6px;

                img {
                    width: 100%;
                    height: 100%;
                    max-width: 76px;
                    max-height: 76px;
                }
            }

            .content {
                margin-left: 4px;
                flex: 8;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .content-title-price-num {
                    display: flex;
                    justify-content: space-evenly;

                    .title {
                        flex: 10;
                        color: #000;
                        line-height: 20px;
                    }

                    .price-and-num {
                        flex: 2;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        margin-right: 3px;

                        .price {
                            color: #000;
                        }

                        .num {
                            color: grey;
                        }
                    }
                }

                .content-specification {
                    color: grey;
                    font-size: 12px;
                }

                .info {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
            }
        }

    }

    .rate_item {
        display: flex;
        align-items: center;

        span {
            margin-right: 6px;
            color: #000;
            font-size: 13px;
        }
    }

    .goodscomment_uploadimg {
        cursor: pointer;
    }

    .create_goods_comment_uploadimg {
        width: 80px;
        height: 80px;
        background-color: #f7f8fa;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        span {
            line-height: 16px;
            font-size: 12px;
            color: #cacaca;
        }

        .van-uploader__input {
            cursor: pointer;
        }
    }
</style>